import styled from 'styled-components';

export const PhoneNumberDisclaimer = styled.div`
  margin-top: 15px;
  font-size: 12px;
  color: var(--cvna-color-blue-6);

  a {
    color: var(--cvna-color-blue-2);

    &:hover {
      color: var(--cvna-color-blue-4);
    }
  }
`;

export const TcpaToggleWrapper = styled.div`
  gap: 15px;
  margin: 15px 0 0 0;
  display: flex;
  color: var(--cvna-color-blue-6);
`;
